import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Heart, Shield, FileCheck, AlertCircle } from 'lucide-react';

const HealthInsurance = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/documentation')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Documentation
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Health Insurance Requirements
          </h1>
          <p className="text-muted-foreground">
            Understanding health insurance requirements for your Polish residence permit application.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Heart className="h-5 w-5 text-primary mr-2" />
                Basic Requirements
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Valid health insurance coverage for entire stay
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Minimum coverage amount requirements
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Coverage for emergency medical treatment
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Proof of payment for insurance premiums
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Shield className="h-5 w-5 text-primary mr-2" />
                Acceptable Insurance Types
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  National Health Fund (NFZ) insurance
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Private health insurance from Polish providers
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  European Health Insurance Card (EHIC)
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Travel insurance with medical coverage
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Common Insurance Issues
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Insufficient coverage period
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Missing coverage for specific treatments
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Insurance from non-recognized providers
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Expired insurance policies
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Help with Insurance?</h2>
            <p className="text-muted-foreground mb-4">
              Our team can help you find the right insurance coverage and ensure it meets all requirements.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Insurance Assistance
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthInsurance; 